export enum Variant {
    DEFAULT = 'default',
    POSITIVE_ACCENT = 'positive-accent',
    NEGATIVE_ACCENT = 'negative-accent',
    EXPLICIT = 'explicit'
}

export type DisplaySize = 'default' | 'medium' | 'large';
